import React, { useState, useEffect } from "react";
import { getAuth } from "firebase/auth";
import {
  doc,
  getDoc,
  updateDoc,
  setDoc,
  collection,
  getDocs,
  query,
  where,
} from "firebase/firestore";
import { firestore, GeoFirestore } from "../../firebase";
import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import Autocomplete from "react-google-autocomplete";
import EditMyLocation from "./editMyLocation";

const auth = getAuth();
const db = firestore;

const LocationSearch = ({ currentBusiness }) => {
  const [userInformation, setUserInfomation] = useState(null);
  const [locations, setLocations] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    auth.onAuthStateChanged(async function (user) {
      if (user) {
        const userDoc = doc(db, "users", user.uid);

        const userInfo = await getDoc(userDoc);
        setUserInfomation(userInfo.data());
      } else {
      }
    });
  }, [auth]);

  useEffect(() => {
    if (userInformation?.moderator !== true) return;

    const fetchLocationData = async () => {
      const usersRef = collection(db, "lokasjoner");
      const q = query(usersRef);

      let locationsArray = [];

      const querySnapshot = await getDocs(q);
      if (!querySnapshot.empty) {
        querySnapshot.forEach((doc) => {
          locationsArray.push(doc.data().locationName);
        });
        setLocations(locationsArray);
      }
    };
    fetchLocationData();
  }, [userInformation]);

  return userInformation?.moderator !== true ? (
    <p>Ingen tilgang</p>
  ) : (
    <>
      <div className='welcomePage'>
        <h1>Søk på lokasjoner</h1>
        {/* <div className='welcomePageContainer'> */}
        <input
          type='text'
          placeholder='Skriv inn navn på lokasjoner'
          style={{
            width: "300px",
            height: "40px",
            fontSize: "16px",
            padding: "10px",
          }}
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
        {/* </div> */}
        <div style={{ marginTop: "20px", marginBottom: "20px" }}>
          {locations.length > 0 && searchQuery.length > 2
            ? locations
                .filter((location) =>
                  location.toLowerCase().includes(searchQuery.toLowerCase())
                )
                .map((location, index) => (
                  <div key={index} style={{ marginBottom: "10px" }}>
                    {location}
                  </div>
                ))
            : null}
        </div>
      </div>
    </>
  );
};

export default LocationSearch;
